
import { formatFormula } from '~/fc/Helpers/UnitHelpers';
import { UnitConfig } from '../../../fc/Constants/config-template'
import { getUnitInfo } from '../../../fc/Dal/UnitRepo'
import Skeleton from /* webpackChunkName: "Skeleton" */ '../../../components/Skeleton.vue'
import Select from /* webpackChunkName: "Select" */ '../../../components/ui/form/basics/UnitSelect'
import SelectSlotted from /* webpackChunkName: "SelectSlotted" */ '../../../components/ui/form/basics/SelectSlotted'

export default {
  name: 'UnitConverter',
  components: {
    Skeleton,
    // eslint-disable-next-line vue/no-reserved-component-names
    Select,
    SelectSlotted
  },
  data: () => ({
    source: 1,
    sourceName: '',
    target: 1,
    targetName: '',
    formula: '',
    selectedType: 'Length',
    loading: true
  }),
  computed: {
    info () { return this.$store.state.info },
    unitTypes () { return UnitConfig(this).groups[0].links },
    sourceList () {
      return this.info.unittype
        ? this.info.unittype.filter(
          utype => utype.name_singular_norm !== this.info.target.name_singular
        )
        : []
    },
    targetList () {
      return this.info.unittype
        ? this.info.unittype.filter(
          utype => utype.name_singular_norm !== this.info.source.name_singular
        )
        : []
    },
    formattedFormula () { return formatFormula(this.formula) }
  },
  watch: {
    formula (val) {
      this.$emit('formulaChange', val)
    }
  },
  mounted () {
    setTimeout(() => {
      this.updateTarget()
      this.loading = false
    }, 10);
    this.initiateUnit()
  },
  methods: {
    initiateUnit () {
      this.sourceName = this.info.source.common_name.replace(/ /g, '-')
      this.targetName = this.info.target.common_name.replace(/ /g, '-')
    },
    async onTypeChange (e) {
      const defaultPages = {
        length: 'cm-to-inches',
        weight: 'grams-to-kg',
        temperature: 'celsius-to-fahrenheit',
        energy: 'ev-to-joules',
        area: 'acres-to-hectares',
        frequency: 'hertz-to-megahertz',
        power: 'gigawatts-to-horsepower',
        electric: 'ohms-to-volt-ampere',
        charge: 'coulombs-to-millicoulombs',
        voltage: 'volts-to-kilovolts',
      }
      await this.updateData(defaultPages[e.target.value], 'source')
      this.initiateUnit()
      this.$bus.$emit('unit-change')
    },
    async updateData (url, type) {
      await getUnitInfo(url, this)
      type === 'source' ? this.updateTarget() : this.updateSource()
    },
    isNumInRange(num){
      const numStr = (num).toString().replace('.', '')
      if (numStr.length > 10) return false
      return true
    },
    convertToExponential(value){
      const num = value.toExponential()
      if (!this.isNumInRange(num)) {
        return value.toExponential(4)
      }
      return num
    },
    updateTarget () {
      if (this.source) {
        const evaluatedValue = this.targetValue(this.source)
        this.target = this.isNumInRange(evaluatedValue) ? evaluatedValue : this.convertToExponential(evaluatedValue)
      }

      this.formula = this.info.sourceFormula.replace('value', this.source + ' ' + this.info.source.abbreviation)
      this.formula += ` = ${this.target} ${this.info.target.abbreviation}`
      this.$bus.$emit('unit-change')
    },
    updateSource () {
      if (this.target) { 
        const evaluatedValue = this.sourceValue(this.target)
        this.source = this.isNumInRange(evaluatedValue) ? evaluatedValue : this.convertToExponential(evaluatedValue)
      }

      this.formula = this.info.targetFormula.replace('value', this.target + ' ' + this.info.target.abbreviation)
      this.formula += ` = ${this.source} ${this.info.source.abbreviation}`
      this.$bus.$emit('unit-change')
    },
    goToPage (type) {
      if (this.sourceName && this.targetName) { this.updateData(this.sourceName + '-to-' + this.targetName, type) }
    },
    roundUp (value) {
      let numStr = value.toString().split('.')
      if (numStr[0].length > 10) {
        return Math.floor(value)
      }
      const fractionalDigit = 10 - numStr[0].length
      const ronded = +(Math.round(value + "e+" + fractionalDigit)  + "e-" + fractionalDigit);
      if (isNaN(ronded))  return value
      return ronded
    },
    targetValue (value) {
      const { sourceFormula } = this.info
      if (!sourceFormula) { return }

      const formula = sourceFormula.replace('value', value)
      // eslint-disable-next-line no-eval
      let result = eval(formula)

      // round upto 6 decimals
      return this.roundUp(result)
    },
    sourceValue (value) {
      const { targetFormula } = this.info
      const formula = targetFormula.replace('value', value)
      // eslint-disable-next-line no-eval
      const result = eval(formula)

      // round upto 6 decimals
      return this.roundUp(result)
    }
  }
}
